import { Input } from "./Input";
import type { Filters as F } from "@/types";

export function Filters({ value, onChange }: { value: F; onChange: (f: F) => void }) {
  function set<K extends keyof F>(k: K, v: F[K]) {
    onChange({ ...value, [k]: v });
  }

  return (
    <div className="flex flex-wrap gap-2">
      <Input
        type="number"
        min={0}
        placeholder="мин. ★"
        aria-label="Минимум звёзд"
        value={value.min_stars ?? ""}
        onChange={(e) => set("min_stars", e.target.value ? Number(e.target.value) : undefined)}
        className="w-28"
      />
      <Input
        placeholder="язык (Python…)"
        aria-label="Язык программирования"
        value={value.language ?? ""}
        onChange={(e) => set("language", e.target.value || undefined)}
        className="w-44"
      />
      <Input
        type="date"
        aria-label="Обновлён после"
        value={value.pushed_after ?? ""}
        onChange={(e) => set("pushed_after", e.target.value || undefined)}
        className="w-44"
      />
      <Input
        placeholder="лицензия (mit…)"
        aria-label="Лицензия"
        value={value.license ?? ""}
        onChange={(e) => set("license", e.target.value || undefined)}
        className="w-36"
      />
    </div>
  );
}
